/* eslint-disable @typescript-eslint/naming-convention */

import { toCurrency } from '../../../shared/utils/toCurrency';

import styled from '@emotion/styled';
import ProfileCardButton from '../../components/ProfileCardButton';
import useSignOut from '../../hooks/useSignOut';
import { useLayoutHeaderContext } from '../../../modules/LayoutHeaderContext';
import useClickOutside from '../../../shared/designSystem/hooks/useClickOutside';
import { globalVariables, S3_RESOURCE_LOGOS } from '../../../shared/designSystem/constants';
import DomainManager from '../../../shared/utils/DomainManager';

import ProfilePopupLink from './ProfilePopupLink';
import { useEnvContext } from '../../../modules/EnvProvider';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ProfilePopup({ isOpen, onClose }: Props) {
  const { isFlightMode, user } = useLayoutHeaderContext();
  const { handleSignOut } = useSignOut();
  const { targetEnv } = useEnvContext();
  const { ref } = useClickOutside(isOpen, [], onClose);
  const { numberOfCoupons, point } = user ?? {};
  const domainManager = new DomainManager(targetEnv);
  const memberDomain = domainManager.getMemberServiceDomain();

  const pointAmount = isFlightMode ? '' : `${toCurrency(String(point))}원`;
  const couponAmount = isFlightMode ? '' : `${toCurrency(String(numberOfCoupons))}장`;

  if (!isOpen) {
    return null;
  }

  return (
    <Container isOpen={isOpen} ref={ref}>
      <ContainerArrow />
      <>
        <InfoSection isWide>
          <ProfileCardButton showDetail />
        </InfoSection>
        <InfoSection>
          <ProfilePopupLink
            label="포인트"
            link={`${memberDomain}/point`}
            desc={pointAmount}
            iconBaseUrl={S3_RESOURCE_LOGOS}
            iconName="logo_mrt_v2_web_point"
          />
          <ProfilePopupLink
            label="쿠폰"
            link={`${memberDomain}/coupon`}
            desc={couponAmount}
            iconName="ico_coupon"
          />
        </InfoSection>
        <InfoSection>
          <ProfilePopupLink
            label="내 회원 등급"
            iconName="ico_loyalty"
            link={`${memberDomain}/grade-benefit`}
          />
        </InfoSection>
        <InfoSection>
          <ProfilePopupLink label="로그아웃" onClick={handleSignOut} />
        </InfoSection>
      </>
    </Container>
  );
}

const Container = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 50px;
  right: 0;
  z-index: ${globalVariables.z_popup};

  width: 230px;
  border: 1px solid ${globalVariables.gray_100};
  background-color: ${globalVariables.white};
  box-shadow: 0 1px 1px 0 rgb(0, 0, 0, 0.2);
  border-radius: 1px;
`;

const ContainerArrow = styled.span`
  display: block;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    display: block;
    width: 0px;
    height: 0px;
    border-style: solid;
  }

  &:after {
    border-color: transparent transparent ${globalVariables.white};
    border-width: 6px;
    right: 12px;
    top: -12px;
  }

  &:before {
    border-color: transparent transparent ${globalVariables.gray_200};
    border-width: 6px;
    right: 12.5px;
    top: -13px;
  }
`;

const InfoSection = styled.div<{ isWide?: boolean }>`
  padding: ${({ isWide }) => (isWide ? '20px 16px;' : '8px 0;')};

  &:not(:last-child) {
    border-bottom: 1px solid ${globalVariables.gray_100};
  }
`;
